import { createHashRouter, RouterProvider } from 'react-router-dom'
import Home from './components/home'
import Projects from './components/projects'
import CV from './components/cv'
import Eriwen from './components/projects/eriwen'
import VoicesOfTheBrave from './components/projects/voicesofthebrave'
import SoldiersWhoDiedInUkraine from './components/projects/soldierswhodiedinukraine'
import UkraineWeapons from './components/projects/ukraineweapons'
import CTCatalogue from './components/projects/ctcatalogue'
import ProjectPage from './components/projects/projectpage'

import Layout from './components/layout'

const router = createHashRouter([
  {
    element: <Layout />,
    children: [
      { path: '/', element: <Home /> },
      { path: '/domu', element: <Home /> },
      { path: '/projekty', element: <Projects /> },
      { path: '/cv', element: <CV /> },

      { path: 'web/:id', element: <ProjectPage category="web" /> },
      { path: 'dalsi/:id', element: <ProjectPage category="dalsi" /> },
      { path: 'zajmy/:id', element: <ProjectPage category="zajmy" /> },
      { path: '/eriwen', element: <Eriwen /> },

      { path: '/voicesofthebrave', element: <VoicesOfTheBrave /> },
      {
        path: '/soldierswhodiedinukraine',
        element: <SoldiersWhoDiedInUkraine />,
      },
      { path: '/ukraineweapons', element: <UkraineWeapons /> },
      { path: '/ctcatalogue', element: <CTCatalogue /> },
    ],
  },
])
const Routes = () => {
  return <RouterProvider router={router} />
}
export default Routes
